<template>
  <specialty-form
    :initialSpecialtyId="initialSpecialtyId"
    :initialSubspecialtyId="initialSubspecialtyId"
    :job-offer="jobOffer"
    @save="onSave"
  />
</template>

<script>
import SpecialtyForm from '@/components/recruiter/form/SpecialtyForm';
export default {
  name: 'SpecialtyInput',
  props: {
    initialSpecialtyId: Number,
    initialSubspecialtyId: Number,
    actionName: String,
    jobOffer: {
      validator: (prop) => typeof prop === 'object',
      required: true,
    },
  },
  components: {
    SpecialtyForm,
  },
  created:function(){
    this.$emit('isJobInfoActive', false);
  },
  methods: {
    onSave: function (data) {
      this.$emit(this.actionName, data);
    },
    isDirty: function () {
      if (!this.$refs.specialtyForm) return false;
      return this.$refs.specialtyForm.isDirty();
    },
    hasErrors: function () {
      if (!this.$refs.specialtyForm) return false;
      return this.$refs.specialtyForm.hasErrors();
    },
    validate: function () {
      if (!this.$refs.specialtyForm) return;
      this.$refs.specialtyForm.validate();
    },
    resetValidation: function () {
      if (!this.$refs.specialtyForm) return;
      return this.$refs.specialtyForm.resetValidation();
    },
  },
};
</script>

<style scoped></style>
